"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationRouterLink = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const next_i18next_1 = require("next-i18next");
const router_1 = require("next/router");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_cross_login_1 = require("@hotelplan/libs.cross-login");
const libs_login_redirect_1 = require("@hotelplan/libs.login-redirect");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const RegisterBaseLink = (0, styled_components_1.default)(components_common_link_1.Link)(({ theme }) => theme.buttons.primary, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    cursor: 'pointer',
    ':hover': {
        color: 'white',
    },
});
function RegistrationRouterLink({ children, language, query, }) {
    query = query || {};
    const router = (0, router_1.useRouter)();
    const callbackUrlQueryParam = (0, libs_cross_login_1.getCallbackUrlQueryParamFromQuery)(router === null || router === void 0 ? void 0 : router.query);
    const route = (0, libs_router_config_1.getRouteByPageTypeLocale)(graphql_types_1.PageType.MyaccountRegistration, language);
    const pathname = route === null || route === void 0 ? void 0 : route.builder({});
    const routerProps = (0, libs_router_link_utils_1.getTargetPageData)({
        targetPageType: route === null || route === void 0 ? void 0 : route.pageType,
        uri: pathname,
    });
    let linkQuery = callbackUrlQueryParam
        ? { [callbackUrlQueryParam.name]: callbackUrlQueryParam.value }
        : {};
    if ((0, isEmpty_1.default)(linkQuery)) {
        const redirectUrlQueryParam = (0, libs_login_redirect_1.getRedirectQueryParamFromQuery)(router === null || router === void 0 ? void 0 : router.query);
        if (redirectUrlQueryParam) {
            linkQuery = { [redirectUrlQueryParam.name]: redirectUrlQueryParam.value };
        }
    }
    query = Object.assign(Object.assign({}, query), linkQuery);
    return (react_1.default.createElement(components_common_router_link_1.RouterLink, { href: {
            pathname: route === null || route === void 0 ? void 0 : route.page,
            query,
        }, as: {
            pathname,
            query,
        }, locale: routerProps === null || routerProps === void 0 ? void 0 : routerProps.locale, passHref: true }, children));
}
exports.RegistrationRouterLink = RegistrationRouterLink;
function RegisterButtonLink(props) {
    const { className } = props;
    const [t, { language }] = (0, next_i18next_1.useTranslation)('auth');
    return (react_1.default.createElement(RegistrationRouterLink, { language: language },
        react_1.default.createElement(RegisterBaseLink, { className: className }, t('auth:register.button'))));
}
exports.default = RegisterButtonLink;
//# sourceMappingURL=RegisterButtonLink.js.map